import { createSlice } from "@reduxjs/toolkit";
import { setSoftone } from "./services";
const initialState = JSON.parse(localStorage.getItem("consentEmailConfig")) || {};

const consentEmailConfig = createSlice({
  name: "consentEmailConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSoftone, (state, action) => {
      localStorage.setItem("consentEmailConfig", JSON.stringify(action.payload.consentEmailConfig));
      return action.payload.consentEmailConfig[0];
    });
  },
});

export default consentEmailConfig.reducer;
